import { useEffect, useMemo, useState } from 'react';
import {
  initMiniApp,
  initThemeParams,
  MiniApp,
  retrieveLaunchParams,
  ThemeParams
} from '@tma.js/sdk';

export interface TelegramContext {
  miniApp: MiniApp | null;
  initDataRaw: string | null;
  userId: string | null;
  username: string | null;
  themeParams: ThemeParams | null;
}

export const useTelegramWebApp = (): TelegramContext => {
  const [miniApp] = useState(() => {
    try {
      return initMiniApp();
    } catch {
      return null;
    }
  });

  const [themeParams] = useState(() => {
    try {
      return initThemeParams();
    } catch {
      return null;
    }
  });

  const launchParams = useMemo(() => {
    try {
      return retrieveLaunchParams();
    } catch {
      return {} as ReturnType<typeof retrieveLaunchParams>;
    }
  }, []);

  useEffect(() => {
    if (miniApp) {
      miniApp.ready();
      miniApp.expand();
    }
  }, [miniApp]);

  const userId = launchParams.initData?.user ? String(launchParams.initData.user.id) : null;
  const username = launchParams.initData?.user?.username ?? null;

  return {
    miniApp,
    initDataRaw: launchParams.initDataRaw ?? null,
    userId,
    username,
    themeParams
  };
};
